<template>
  <div :id="'echartid'+configs.id" style="width: 100%; height: 100%"></div>
</template>

<script>
export default {
  name: "echart-instrument",
  props:{
    configs: [Object,Array,String]
    // calendarTypeOptions:Array,
    // sortOptions:Array,
    // temp:Object
  },
  data () {
    return {

      }
  },
  mounted(){
    // this.drawline2diagram()
  },
  methods:{
    drawline2diagram (data) {
      const $this=this
      const myEchartst = this.$echarts.init(document.getElementById('echartid'+this.configs.id))
      let option = {
        series: [
          {
            type: 'gauge',
            title:{
              textStyle: {
                color:'#fff',
                fontSize:14
              }
            },
            axisLine: {
              lineStyle: {
                width: $this.configs.datawidth || 20,
                color: $this.configs.datacolor || [
                  [0.3, '#67e0e3'],
                  [0.7, '#37a2da'],
                  [1, '#fd666d']
                ]
              }
            },
            pointer: {
              itemStyle: {
                color: 'auto'
              }
            },
            axisTick: {
              distance: $this.configs.datawidth ? ($this.configs.datawidth * -1):-20,
              length: 6,
              lineStyle: {
                color: '#fff',
                width: 2
              }
            },
            splitLine: {
              distance: $this.configs.datawidth ? ($this.configs.datawidth * -1):-20,
              length: $this.configs.datawidth || 20,
              lineStyle: {
                color: '#1C6D99',
                width: 3
              }
            },
            axisLabel: {
              color: 'auto',
              distance: 25,
              fontSize: 13
            },
            detail: {
              valueAnimation: true,
              formatter: $this.configs.formatter || '{value}',
              color: 'auto',
              textStyle:{
                fontSize: 18,
                color:'#52AEE0'
              }
            },
            data: [
              {
                value: $this.configs.value,
                name:$this.configs.name
              }
            ]
          }
        ]
      }
      myEchartst.setOption(option)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/echart-instrument.vue